import { ServiceCardIcon } from '@icons';
import { CaseOutcome } from '@features/components/CaseCard/Blocks/Base/CaseOutcome';
import { getColorsByOrganType } from '@/utils/helpers';
import { BaseCaseCard, BaseCaseCardProps } from './BaseCaseCard';
import { dispositionSpecificationNames, dryRunReasonNames } from '@/constants/case/case.constants';
import { DispositionSpecificationType } from '@/api/apis/case';
import { declineDataHeight, gapHeight } from '../../constants';

export const CaseCardWithServiceDeclined = ({ caseData, onClick }: BaseCaseCardProps) => {
  const { organType, outcomeData } = caseData;
  const colors = getColorsByOrganType(organType);
  if (!outcomeData) return <BaseCaseCard caseData={caseData} onClick={onClick} />;

  const { dispositionReason, dispositionSpecification } = outcomeData;
  const specificationName = dispositionSpecificationNames[dispositionSpecification];
  const specificationString =
    !dispositionSpecification || specificationName === DispositionSpecificationType.None ? '' : `${specificationName}`;

  return (
    <BaseCaseCard extraHeight={declineDataHeight + gapHeight} caseData={caseData} onClick={onClick}>
      <div className="w-full flex flex-col gap-2">
        <CaseOutcome caseData={caseData} />
        <div className={`rounded-md p-2 h-16 flex gap-1 ${colors.bg80}`}>
          <div className="w-9">
            <ServiceCardIcon />
          </div>
          <div>
            <div className="text-s-m">{dryRunReasonNames[dispositionReason] || dispositionReason}</div>
            <div className="text-s-r text-base-10 line-clamp-2">{specificationString}</div>
          </div>
        </div>
      </div>
    </BaseCaseCard>
  );
};
